<div class="cdp-header">
  <button class="cdp-nav" mat-icon-button type="button" (click)="prev()">
    <mat-icon>chevron_left</mat-icon>
  </button>

  @if (isYearPickerEnabled) {
    <button class="cdp-period-btn" mat-button type="button" (click)="handlePeriodLabel()">
      {{ label }}
      <mat-icon class="cdp-period-chevron">{{ isMonthView ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon>
    </button>
  } @else {
    <div class="cdp-period-label">{{ label }}</div>
  }

  <button class="cdp-nav" mat-icon-button type="button" (click)="next()">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
